export type BackofficePaymentLocation = {
    id: number;
    name: string;
};

const types = {
    ACCESS_DESTROY_FAILED: "BACKOFFICEPAYMENT_PERMISSION/ACCESS_DESTROY_FAILED",
    ACCESS_DESTROY_REQUEST:
        "BACKOFFICEPAYMENT_PERMISSION/ACCESS_DESTROY_REQUEST",
    ACCESS_DESTROY_SUCCESS:
        "BACKOFFICEPAYMENT_PERMISSION/ACCESS_DESTROY_SUCCESS",

    ACCESS_FETCH_FAILED: "BACKOFFICEPAYMENT_PERMISSION/ACCESS_FETCH_FAILED",
    ACCESS_FETCH_REQUEST: "BACKOFFICEPAYMENT_PERMISSION/ACCESS_FETCH_REQUEST",
    ACCESS_FETCH_SUCCESS: "BACKOFFICEPAYMENT_PERMISSION/ACCESS_FETCH_SUCCESS",

    ACCESS_UPDATE_FAILED: "BACKOFFICEPAYMENT_PERMISSION/ACCESS_UPDATE_FAILED",
    ACCESS_UPDATE_REQUEST: "BACKOFFICEPAYMENT_PERMISSION/ACCESS_UPDATE_REQUEST",
    ACCESS_UPDATE_SUCCESS: "BACKOFFICEPAYMENT_PERMISSION/ACCESS_UPDATE_SUCCESS",

    LOCATIONS_FETCH_FAILED:
        "BACKOFFICEPAYMENT_PERMISSION/LOCATIONS_FETCH_FAILED",
    LOCATIONS_FETCH_REQUEST:
        "BACKOFFICEPAYMENT_PERMISSION/LOCATIONS_FETCH_REQUEST",
    LOCATIONS_FETCH_SUCCESS:
        "BACKOFFICEPAYMENT_PERMISSION/LOCATIONS_FETCH_SUCCESS",

    LOCATIONS_ROLES_FAILED:
        "BACKOFFICEPAYMENT_PERMISSION/LOCATIONS_ROLES_FAILED",
    LOCATIONS_ROLES_REQUEST:
        "BACKOFFICEPAYMENT_PERMISSION/LOCATIONS_ROLES_REQUEST",
    LOCATIONS_ROLES_SUCCESS:
        "BACKOFFICEPAYMENT_PERMISSION/LOCATIONS_ROLES_SUCCESS",
};

export default types;
